<template>

        <div>

            <div class="button is-large" @click="toggleFilter('destination')" :aria-expanded="selectedFilter === 'destination' ? 'true' : 'false'">
                <span class="m-r-md">{{ $t('shop.search.filters.destinations') }}</span>
                <span class="icon is-small is-angle">
                    <i class="fa fa-angle-down"></i>
                </span>
            </div>


            <div class="button is-large" @click="toggleFilter('theme')" :aria-expanded="selectedFilter === 'theme' ? 'true' : 'false'">
                <span class="m-r-md">{{ $t('shop.search.filters.themes') }}</span>
                <span class="icon is-small is-angle">
                    <i class="fa fa-angle-down"></i>
                </span>
            </div>

            <div class="button is-large" @click="toggleFilter('date')" :aria-expanded="selectedFilter === 'date' ? 'true' : 'false'">
                <span class="m-r-md">{{ $t('shop.search.filters.date') }}</span>
                <span class="icon is-small is-angle">
                    <i class="fa fa-angle-down"></i>
                </span>
            </div>

            <!--<div class="button is-large" @click="toggleFilter('duration')" :aria-expanded="selectedFilter === 'duration' ? 'true' : 'false'">
                <span class="m-r-md">{{ $t('shop.search.filters.duration') }}</span>
                <span class="icon is-small is-angle">
                    <i class="fa fa-angle-down"></i>
                </span>
            </div>-->

            <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="selectedFilter === 'destination'" :key="'destination'">
                    <div class="section box filter-content">
                        <div class="columns is-multiline" >
                            <div class="column is-one-quarter-desktop is-half-tablet" v-for="destination in destinationsList">
                                <div class="card-image">
                                    <span class="has-text-white">
                                        <figure class="image is-3by2 m-b-none">
                                            <img :src="'/img/campus/'+destination.image" alt="">
                                        </figure>
                                        <div class="is-overlay is-clipped">
                                            <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                                <b-checkbox v-model="offerFilters.destinations"
                                                            :native-value="destination.id">

                                                    {{ destination.name }}
                                                </b-checkbox>

                                            </h2>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="selectedFilter === 'theme'">
                    <div class="section box filter-content">
                        <div class="columns is-multiline" >
                            <div class="column is-one-third-desktop is-half-tablet" v-for="theme in themesList">
                                <b-checkbox v-model="offerFilters.themes"
                                            :native-value="theme.id">{{ theme.name.fr }}</b-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="selectedFilter === 'date' &&  sessionEvents.length">
                    <div class="section box filter-content ">
                        <div class="columns is-multiline" >
                            <div class="column is-half is-offset-one-third has-text-centered">
                                <b-datepicker v-model="date"
                                              inline
                                              :events="sessionEvents"
                                              :indicators="indicators"
                                              :min-date="minDate"
                                              @input="selectedDate()">
                                </b-datepicker>
                            </div>
                        </div>

                    </div>

                </div>
            </transition>

            <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
            <div v-if="selectedFilter === 'duration'">
                <div class="section box filter-content">
                    <div class="columns is-multiline" >

                        <b-radio v-model="offerFilters.durations"
                                 required
                                 name="medical"
                                 native-value="1">
                            <i>{{ $tc('offers.search.filters.week', 1, { n: 1 }) }}</i>
                        </b-radio>
                        <b-radio v-model="offerFilters.durations"
                                 name="medical"
                                 native-value="2">
                            {{ $tc('offers.search.filters.week', 2, { n: 2 }) }}
                        </b-radio>
                        <b-radio v-model="offerFilters.durations"
                                 name="medical"
                                 native-value="3">
                            {{ $tc('offers.search.filters.week', 3, { n: 3 }) }}
                        </b-radio>
                        <b-radio v-model="offerFilters.durations"
                                 name="medical"
                                 native-value="4">
                            {{ $tc('offers.search.filters.week', 4, { n: 4 }) }}
                        </b-radio>


                    </div>
                </div>
            </div>
            </transition>




            <div class="p-md filter-selection">
                <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="offerFilters.date" class="m-b-md">
                    <div class="is-size-5 has-text-weight-light is-italic heading-line m-b-sm"><span>{{ $t('shop.search.filters.date') }}</span></div>
                    <span class="filter-tag" >{{ formatDate(offerFilters.date) }}
                        <span class="icon is-small" >
                          <i class="fa fa-close" @click="deleteOfferFilter({category:'date', selected:offerFilters.date})"></i>
                        </span>
                    </span>
                </div>
                </transition>
                <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="offerFilters.durations" class="m-b-md">
                    <div class="is-size-5 has-text-weight-light is-italic heading-line m-b-sm"><span>{{ $t('shop.search.filters.duration') }}</span></div>
                    <span class="filter-tag" v-for="duration in offerFilters.durations">{{ $tc('offers.search.filters.week', duration, { n: duration }) }}
                        <span class="icon is-small" >
                          <i class="fa fa-close" @click="deleteOfferFilter({category:'duration', selected:duration})"></i>
                        </span>
                    </span>
                </div>
                </transition>
                <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="offerFilters.destinations.length" class="m-b-md">
                    <div class="is-size-5 has-text-weight-light is-italic heading-line m-b-sm"><span>{{ $t('shop.search.filters.destinations') }}</span></div>
                    <span class="filter-tag" v-for="destination in offerFilters.destinations">{{ campusById(destination).name }}
                        <span class="icon is-small" >
                          <i class="fa fa-close" @click="deleteOfferFilter({category:'destination', selected:destination})"></i>
                        </span>
                    </span>
                </div>
                </transition>
                <transition name="slide-fade" mode="out-in" :duration="{ enter: 200, leave: 200 }">
                <div v-if="offerFilters.themes.length && offerFilter" class="m-b-md">
                    <div class="is-size-5 has-text-weight-light is-italic heading-line m-b-sm"><span>{{ $t('shop.search.filters.themes') }}</span></div>
                    <span class="filter-tag" v-for="theme in offerFilters.themes">{{ themeById(theme).name.fr }}
                        <span class="icon is-small" >
                          <i class="fa fa-close" @click="deleteOfferFilter({category:'theme', selected:theme})"></i>
                        </span>
                    </span>
                </div>
                </transition>

            </div>

            <hr>
        </div>


</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import api from 'services/offers'
    const thisMonth = new Date().getMonth()+1
    export default {
        data () {
            const today = new Date()
            return {
                selectedFilter: null,
                sessionEvents: [],
                bars: true,
                date: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
                minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2)
            }
        },
        props: {
            offerFilter: {type: Boolean}
        },
        computed: {
            ...mapGetters('organization', [
                'getSchoolBySlug'
            ]),
            ...mapGetters(
                'offers', [
                    'selectedCategory'
                ]
            ),
            ...mapGetters(
                'sessions', [
                    'offerFilters'
                ]
            ),
            indicators() {
                return this.bars ? 'bars' : 'dots'
            },
            destinationsList() {
                const school = this.getSchoolBySlug(this.$route.params.school)
                if (school) {
                    return school.campuses
                }
            },
            themesList() {
                return this.selectedCategory.themes
            }
        },
        watch: {
            offerFilters: {
                handler(filters) {
                    if (filters.date !== null || filters.destinations.length || filters.durations !== null || filters.themes.length) {
                        this.$emit('filter', filters)
                    }else{
                        this.$emit('filter', null)
                    }
                    this.fetchSessionsEvents()

                },
                deep: true
            }
        },
        methods: {
            ...mapActions(
                'organization', [
                    'fetchCampuses'
                ]
            ),
            ...mapActions(
                'offers', [
                    'selectCategory'
                ]
            ),
            ...mapActions(
                'sessions', [
                    'deleteOfferFilter'
                ]
            ),
            fetchSessionsEvents () {
                api.sessionsEvents(this.offerFilters).then((result) => {
                    const dates = result.data

                    dates.map(function (date) {
                        date.date = new Date(moment(date.date).year(), moment(date.date).month(), moment(date.date).date())
                    })

                    this.sessionEvents = dates

                }).catch(e => {
                })
            },
            formatDate(date) {
                return moment(date, 'YYYY-MM-DD hh:mm:ss').format('LL')
            },
            campusById(id) {
                return this.destinationsList.find(i => i.id === id);
            },
            themeById(id) {
                return this.themesList.find(i => i.id === id);
            },
            selectedDate() {
                this.offerFilters.date = moment(this.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.selectedFilter = null
            },
            toggleFilter(filter) {
                this.selectedFilter = this.selectedFilter !== filter ? filter:null
            }
        },
        created () {
            this.fetchCampuses()
            this.selectCategory(this.$route.params.categoryId)
            this.fetchSessionsEvents()

        }
    }
</script>

<style lang="scss" scoped >
    img {
        object-fit: cover;
    }

    .card-footer-item .checkbox:hover {
        color: #fff;
    }

    /*.filter-content {
        background-color: #fff;
        position: absolute;
        z-index: 1000;
        width: 95%;
    }*/

    .filter-tag {
        position: relative;
        margin-right: 0.625rem;
        margin-bottom: 0.625rem;
        display: inline-block;
        padding: 0.5rem 0.625rem;
        vertical-align: middle;
        color: #fff;
        background-color: rgba(36, 54, 101, 0.87);
    }

    .filter-tag i{
        cursor: pointer;
    }

    .icon {
        vertical-align: baseline;
        &.is-angle {
            position: absolute;
            right: 10px;
            transition: transform .377s ease;
        }
    }


    .button {
        &[aria-expanded="true"] {
            .is-angle {
                transform: rotate(180deg);
            }
        }
    }


</style>
